const SERVER_URL = import.meta.env.VITE_SERVER_BASE_URL;

export const backToJobList = () => {
  window.location.replace(`${SERVER_URL}/job/myActiveJobs`);
};
